<template>
  <div class="box">
    <com-h1 :title="title"></com-h1>
    <com-swipe :items="hotGuests"></com-swipe>
  </div>
</template>
<script>
import comH1 from 'gkConUI/com-h1'
import comSwipe from './com-swipe'
export default {
  data () {
    return {}
  },
  components: {
    comH1,
    comSwipe
  },
  props: ['hotGuests', 'title']
}
</script>
<style scoped lang='sass'>
</style>
